import { useEffect, useState } from "react";
import RoundInfoItem from "../RoundInfoItem/RoundInfoItem";
import styles from "./RoundGrid.module.scss";

const RoundGrid = ({ title, subtitle, items, more, less, contactsLabel, tier, locked_phrase }) => {
  const [list, setList] = useState([])

  useEffect(() => {
    if (items && items.length > 0) {
      setList(items.map((e, i) => (
        <RoundInfoItem
          key={i}
          infoImage={e.image}
          info={e.title}
          moreInfos={e.text}
          more={more}
          less={less}
          button={e.link}
          contactsLabel={contactsLabel}
          contacts={e.contacts ? e.contacts : null}
          loyalty={e.loyalty_level ? e.loyalty_level : null}
          tier={tier}
          locked_phrase={locked_phrase}
        />
      )))
    }
  }, [items]);

  return (
    <div className={styles.roundGrid}>
      <div className={styles.title}>{title}</div>
      {subtitle && <div className={styles.subtitle} dangerouslySetInnerHTML={{ __html: subtitle }} />}
      <div className={styles.gridContent}>
        {list}
      </div>
    </div>
  );
};

export default RoundGrid;
